/* eslint-disable @typescript-eslint/no-explicit-any */
export class Alert {
  type: AlertType;
  message: string;
  title: string;
  id!: string;
  delay: null | number;
  keepAfterRouteChange: boolean;
  isVisible: boolean;
  close: boolean;
  icon: string;
  userData: any;
  position: PositiionType;
  constructor(init?: Partial<Alert>) {
    this.type = AlertType.success;
    this.message = '';
    this.title = '';
    this.delay = 5000;
    this.keepAfterRouteChange = false;
    this.isVisible = false;
    this.close = true;
    this.icon = ''
    this.position = PositiionType.TopCenter;
    Object.assign(this, init);
  }
}

export enum AlertType {
  success = "success",
  error = "error",
  info = "info",
  warning = "warning",
  default = 'default',
}

export enum PositiionType {
  TopCenter = 0,
  TopLeft = 1,
  TopRight = 2,
  BottomCenter = 3,
  BottomLeft = 4,
  BottomRight = 5,
  Middle = 6,
}
